// Externe Bibliotheken
import { Link } from 'react-router';

// Styles
import './emergencyContactModal.scss';

interface EmergencyContactModalProps {
    name: string;
    phone: string;
    mail: string;
}

const EmergencyContactModal = ({ name, phone, mail }: EmergencyContactModalProps) => {
    return (
        <>
            <div className="contact-data">
                {name && (
                    <>
                        <div className="contact-data-headline">
                            <i className="material-symbols-outlined">emergency</i>
                            {`Kontaktdaten für ${name}`}
                        </div>
                        <div className="contact-data-row">
                            <div>Name</div>
                            <div>{name}</div>
                        </div>
                    </>
                )}
                {phone && (
                    <div className="contact-data-row">
                        <div>Handynummer</div>
                        <div>{phone}</div>
                    </div>
                )}
                {mail && (
                    <div className="contact-data-row">
                        <div>Email Adresse</div>
                        <div>{mail}</div>
                    </div>
                )}
            </div>
            <Link to="/notfall-kontakt" className="button-element">
                Kontaktdaten ändern
            </Link>
        </>
    );
};
export default EmergencyContactModal;
